import { UsersService } from './users-service';

const usersService = new UsersService();

export { usersService };
